'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _tuneInRequest = require('../tuneInRequest');

var _tuneInRequest2 = _interopRequireDefault(_tuneInRequest);

var _OpmlError = require('../errors/OpmlError');

var _transformOpmlResponseData = require('../utils/transformOpmlResponseData');

var _transformOpmlResponseData2 = _interopRequireDefault(_transformOpmlResponseData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function loggingService(config, apiContext, applyReauth) {
  var infoLogEndpoint = config.domains.local + '/log/info/';
  var errorLogEndpoint = config.domains.local + '/log/error/';
  var reportEndpoint = config.domains.opml + '/Report.ashx';

  function reportingRequest(requestConfig, body) {
    if (body) {
      return _extends({}, requestConfig, {
        data: body,
        method: 'post'
      });
    }

    return requestConfig;
  }

  function errorLog(body) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: errorLogEndpoint,
      data: body
    }, apiContext);
  }

  function infoLog(body) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: infoLogEndpoint,
      data: body
    }, apiContext);
  }

  function report(params, body) {
    var requestConfig = reportingRequest({
      method: 'get',
      url: reportEndpoint,
      params: params,
      transformResponse: _transformOpmlResponseData2.default,
      disableRetry: true
    }, body);

    return (0, _tuneInRequest2.default)(requestConfig, apiContext).then(_OpmlError.handleOpmlError);
  }

  function eventLog(params, body) {
    var requestConfig = reportingRequest({
      method: 'get',
      url: reportEndpoint,
      params: params,
      transformResponse: _transformOpmlResponseData2.default,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      disableRetry: true
    }, body);

    return (0, _tuneInRequest2.default)(requestConfig, apiContext).then(_OpmlError.handleOpmlError);
  }

  return {
    eventLog: eventLog,
    errorLog: errorLog,
    infoLog: infoLog,
    report: applyReauth(report)
  };
};
//# sourceMappingURL=logging.js.map